import type { ProjectId } from "features/shared/model/types";
import type { QueryClient } from "react-query";

import { useGeneralPaginatedAllPagesFetchHook } from "api/hooks/allHooks";

import type { ProcessingJob } from "../model/types";

import { EXECUTION_CACHE_KEYS } from "./cacheKeys";
import { usePollWhileJobsInProgress } from "./hooks/usePollWhileJobsInProgress";
import executionUrls from "./urls";

export const refreshProcessingJobs = async (
  queryClient: QueryClient,
  projectId: ProjectId,
  job?: ProcessingJob
) => {
  await queryClient.invalidateQueries(EXECUTION_CACHE_KEYS.PROCESSING_JOBS(projectId));
  if (!job) return;
  queryClient.setQueryData<ProcessingJob[]>(EXECUTION_CACHE_KEYS.PROCESSING_JOBS(projectId), (current) => {
    const jobs = current ?? [];
    if (jobs.some((item) => item.job_id === job.job_id)) return jobs;
    return [job, ...jobs];
  });
};

export const useGetProcessingJobs = (projectId: ProjectId, enabled = false) => {
  const url = executionUrls.processingJobsByProject(projectId!);
  const query = useGeneralPaginatedAllPagesFetchHook<ProcessingJob>({
    cacheName: EXECUTION_CACHE_KEYS.PROCESSING_JOBS(projectId),
    rest: { enabled: enabled && Boolean(projectId) },
    url,
  });

  usePollWhileJobsInProgress(query);

  return query;
};
